import makeRedirectLink from "@client/content/controls/Link/Redirect/container";
import { withAnimate } from "@client/content/hocs";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { combinedSettingsSelector, makeAnimationOptionsSelector } from "@client/selectors";
import { type AppState } from "@client/types";
import classnames from "classnames";
import Component, { type ButtonBaseProps } from "./component";
import { makeIconStyleSelector, makeStyleWithAlignSelector } from "./selectors";

export type IconHolder = "btn-icon-holder-off" | "btn-icon-left" | "btn-icon-right";

export type ButtonContainerPropsBase = RootContainerProps & {
  caption?: string;
  captionPropPath?: string;
  captionPropName?: string;
  className?: string;
  icon?: string | null;
  iconHolder?: IconHolder;
  isDisabled?: boolean;
  isEditMode?: boolean; // in some cases we want the button to be clickable
  onClick?: (e: React.MouseEvent) => void;
  style?: React.CSSProperties;
  tooltip?: string;
};

type MakeButtonOptions = {
  captionPropPath?: string;
  excludeMargin?: boolean;
};
const makeButton = <TProps extends ButtonContainerPropsBase>(
  target: string,
  prefix?: string,
  opts?: MakeButtonOptions
) => {
  const RedirectLink = makeRedirectLink(target, prefix);
  // TODO: TS issue
  const AnimatedLink = withAnimate(RedirectLink as any);

  const makeMapStateToProps = () => {
    const animationOptionsSelector = makeAnimationOptionsSelector(target, prefix);
    const iconStyleSelector = makeIconStyleSelector(target, prefix);
    const styleSelector = makeStyleWithAlignSelector(target, prefix, opts?.excludeMargin);

    const otherSettingsSelector = combinedSettingsSelector(
      target,
      ["iconHolder", "outline", "icon", "caption"],
      prefix
    );

    return (state: AppState, props: TProps): ButtonBaseProps => {
      const { iconHolder = "btn-icon-left", outline, icon, caption } = otherSettingsSelector(state, props);

      const ih = props.iconHolder ?? iconHolder;
      return {
        ...props,
        animationOptions: animationOptionsSelector(state, props),
        className: classnames("btn btn_styled", ih, outline, `_${prefix}`, props.className),
        icon: props.icon ?? icon,
        iconHolder: ih,
        iconStyle: iconStyleSelector(state, props),
        isDisabled: props.isDisabled,
        isEditMode: props.isEditMode ?? state.isEditMode,
        Link: AnimatedLink as any, // TODO: TS issue
        style: styleSelector(state, props),
        captionPropPath: props.captionPropPath ?? opts?.captionPropPath ?? "button",
        captionPropName: props.captionPropName ?? "caption",
        caption: props.caption ?? caption
      };
    };
  };

  return connectCustom(makeMapStateToProps)(Component);
};
export default makeButton;
